
import React from 'react';
import axios2 from 'services/axios2';

import {useParams} from 'react-router-dom';
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { NuDropdown } from 'components/nubox/NuDropdown';

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";
import CardEstu from "components/CardEstu";
import ModalEstCarrera from './ModalEstCarrera';

import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
} from 'reactstrap';
import NuListSearch from 'components/nubox/NuListSearch';


const data = [
  //{ id_medico: 1,  nombre: 'ALEX LIZARRAGA',  especialidad: '00000023',tel:''}, 
];
const data1 = [
  { value: 1, label: "Apple" },
  { value: 2, label: "Facebook" },
];
/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class InscribirEstXCi extends React.Component {  

  
  
  state = {
    modalInsertar: false,
    
        
    form: {
      id_est: 0,
      estudiante:'',
    },
    data: data,/* lista de datos */

    //carreras_arr: [],
    item_selected:{},
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
    this.modalRef = React.createRef();//create ref
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de datos
    this.setState({data:[]});
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  //------------
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  //------------------------

  //------------------------
  onHandleOk =( item ) =>{
    console.log("onHandleOk")
    console.log(item)
    //---------cargamos el detalle en la otra tabla
    //this.get_carreras(key)  //en este caso el id_u del docente
    //this.setState({form})
    let id_est = item.id_est

    this.setState({form:{...this.state.form, 
                          id_est: item.id_est,
                          estudiante: item.nomape_tmp }}); 

    this.cargar_data(id_est)
  }
  //====================================================== 
  // item tiene value, label
  cargar_data = (id_est) => {
    let user = this.props.store.user
    let param = { 
      id_est: id_est,
      id_peri: user.id_peri
    }
    console.log(param);
    axios2.post( 'inscribir_est_x_ci_get_list', param)
    .then(res => {
      console.log(res.data)
      
      if(res.data.length>0){ 
          this.setState({data: res.data});
          //---establecer como inicial
          //this.setState({form: res.data[0] });
      }else{
          this.setState({data: []});
          NotificationManager.error('No existen datos');
      }

    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
        
    });

    //---establecemos como item_selected
    //this.setState({ item_selected: item});
  };
  //======================================================     
  imprimirBoleta =(id_inscrip)=>{
    let fileURL = process.env.REACT_APP_API_URL  + 'inscripcion_pdf/'+ id_inscrip;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  /* === This is where the magic happens ==== */
  /*handleSubmit = event => {
    event.preventDefault();
    this.cargar_data();
  }*/
  //-----------------------------------------------------------------

  //-----------------------------------------------------------------
  //-----------------------------------------------------------------
  nuevo = () => {
    console.log(this.state.item_selected)

    if(this.state.item_selected!==null){
      console.log(this.modalRef.current);

      //-----------sacamos datos del localStorage
      let id_peri = this.props.store.user.id_peri;
      let periodo = this.props.store.user.periodo;

      console.log("id_peri:" + id_peri, "periodo:" + periodo )
      let id_est = this.state.form.id_est
      let estudiante = this.state.form.estudiante
      this.modalRef.current.nuevo( id_est, estudiante, id_peri, periodo);
    }
  }
  //-----------------------------------------------------------------
  /*
  eliminar = (item) =>{
    console.log('eliminar');
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        let idd = item.id_doc_mat;
        //this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }*/
  //-------------------------------------
  okModal =()=>{
    console.log('citaOkModal');
    //---recargamos la tabla
    this.cargar_data(this.state.form.id_est);
  }
  //-------------------------------------
  closeModal =()=>{
    console.log('citaCancelModal');
  }
  //------------------------------------
  //-------------------------------------
  render() {
  
    return (
      <div>
      
        { 
         // JSON.stringify( this.state.form )
        }
        <div className='content'>

          {/*{/*--- -----------------------------*/}
          <div className='row'>
            <div className='col-md-12'>
              <h3> Inscribir estudiante por C.I.</h3>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-3'>
              <CardEstu
                handleOk={ this.onHandleOk }
              />
             
            </div>
            {/** */}
            <div className='col-md-9'>
              <div className='top_title2'>
                <div className='row'>
                  <div className='col-md-12'>
                    
                  
                    <div className=' pull-right'>
                      
                      <Button onClick={() => this.nuevo()} 
                        className='create-modal btn btn-info ' >
                        <i className='fa fa-plus'></i> Nuevo 
                      </Button>
                      
                    </div>
                    <h4>Carrera: { this.state.item_selected.label }</h4>
                  </div>
                </div>
              </div>

              <table className='table table-striped table-hover' width='100%' align='center'>
                <thead>
                  <tr>
                    <th>Cod. Inscrip.</th>
                    <th>Nombre</th>
                    <th>C.I.</th>
                    <th>Carrera</th>
                    <th>Accion</th>
                  </tr>

                </thead>
                <tbody>
                  {/* className='text-left' */}
                  
                  {this.state.data.map((item, index) => (
                    <tr key={index}> 
                      <td>{ item.id_inscrip }</td>
                      <td>{ item.nomape_tmp }</td>
                      <td>{ item.nro_doc }</td>
                      <td>{ item.nombreca }</td>

                      <td>
                        <Button className='btn btn-warning btn-sm' title='Habilitar' 
                          onClick={() => this.imprimirBoleta(item.id_inscrip)}>
                          <i className='fa fa-edit'></i> Imprimir Boleta
                        </Button>
                      </td>
                    </tr>
                  ))}



                </tbody>
              </table> 
            </div>
            {/** */}
            
          </div>


        
          
          {/*-- */}
          <div className="row">
             
          </div>
          {/*-- */}

          

        </div>
        
        <ToastContainer />
        <NotificationContainer/>
        <NuConfirm   ref={ this.refNuConfirm }    />
        <ModalEstCarrera
          ref={this.modalRef}
          okModal={this.okModal}
          closeModal={this.closeModal}
        />
      </div>
      
    );
  }
}
//------------para que soporte la funcionalidad de parametros

export default withRouterJim (InscribirEstXCi);